import GoogleButton from "./GoogleButton";
import AppleButton from "./AppleButton";

type Props = {
  onGoogle?: () => void;
  onApple?: () => void;
};

export default function SocialLoginSection({
  onGoogle,
  onApple,
}: Props) {
  return (
    <>
      <GoogleButton onClick={onGoogle} />

      <AppleButton onClick={onApple} />
    </>
  );
}